import { ACTION_STATUS } from "../actionbar-detail.constant";
import { ButtonBase } from "./button.base";

export class PassportIndividualButtonModel extends ButtonBase {
    label: string = 'Passport';
    action: string = ACTION_STATUS.passportIndiviDual;
    matIconName: string = 'account_box';
    colorClass: string = 'color-info-500';
}